import React, { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import { colors } from '@kontentino/ui';
import AiCaptionGenerator from './modules/aiCaptionGenerator';

const FreeToolsBestTimeToPost = lazy(() => import('./modules/bestTimeToPost'));
const InstagramFeedPreview = lazy(
  () => import('./modules/instagramFeedPreview'),
);
const LinkShortener = lazy(() => import('./modules/linkShortener'));
const UtmTagBuilder = lazy(() => import('./modules/utmTagBuilder'));
const AiHashtagGenerator = lazy(() => import('./modules/aiHashtagGenerator'));
const AiUsernameGenerator = lazy(() => import('./modules/aiUsernameGenerator'));
const AiBioGenerator = lazy(() => import('./modules/aiBioGenerator'));
const AiCommentGenerator = lazy(() => import('./modules/aiCommentGenerator'));
const TiktokFeedPreview = lazy(() => import('./modules/tiktokFeedPreview'));
const YoutubeFeedPreview = lazy(() => import('./modules/youtubeFeedPreview'));
const PinterestFeedPreview = lazy(
  () => import('./modules/pinterestFeedPreview'),
);

export const publicFreeToolsRouter: RouteObject = {
  path: routeConfig.public.routes.freeTools.path,
  element: (
    <>
      <style>
        {`
          body {
            background-color: ${colors.white};
          }        
        `}
      </style>
      <Outlet />
    </>
  ),
  children: [
    {
      path: routeConfig.public.routes.freeTools.routes.bestTimeToPost.path,
      element: <FreeToolsBestTimeToPost />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.instagramFeedPreview
        .path,
      element: <InstagramFeedPreview />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.linkShortener.path,
      element: <LinkShortener />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.utmTagBuilder.path,
      element: <UtmTagBuilder />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.aiCaptionGenerator.path,
      element: <AiCaptionGenerator />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.aiHashtagGenerator.path,
      element: <AiHashtagGenerator />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.aiUsernameGenerator.path,
      element: <AiUsernameGenerator />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.aiBioGenerator.path,
      element: <AiBioGenerator />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.aiCommentGenerator.path,
      element: <AiCommentGenerator />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.tiktokFeedPreview.path,
      element: <TiktokFeedPreview />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.youtubeFeedPreview.path,
      element: <YoutubeFeedPreview />,
    },
    {
      path: routeConfig.public.routes.freeTools.routes.pinterestFeedPreview
        .path,
      element: <PinterestFeedPreview />,
    },
  ],
};
